/**
 * Looping Lottie hero background for mobile (< 900px); replaces the static image
 * behind .jitter-mobile-hero-text. Desktop is untouched (CSS keeps this hidden).
 */

import lottie from 'lottie-web/build/player/lottie_light';

const MOBILE_MAX_WIDTH = 899;

/** SVG slice + top align = background-size: cover; background-position: top center */
const lottieCoverSettings = {
	preserveAspectRatio: 'xMidYMin slice',
};

/**
 * @return {{ destroy: () => void }}
 */
export function initJitterMobileHero() {
	const container = document.querySelector('.jitter-mobile-hero-lottie');
	const url = container?.getAttribute('data-lottie-src');

	if (!container || !url) {
		return { destroy() {} };
	}

	const mq = window.matchMedia(`(max-width: ${MOBILE_MAX_WIDTH}px)`);
	/** @type {import('lottie-web').AnimationItem | null} */
	let anim = null;

	const start = () => {
		if (anim) {
			return;
		}
		anim = lottie.loadAnimation({
			container,
			renderer: 'svg',
			loop: true,
			autoplay: true,
			path: url,
			rendererSettings: lottieCoverSettings,
		});
	};

	const stop = () => {
		anim?.destroy();
		anim = null;
	};

	const onMqChange = () => {
		if (mq.matches) {
			start();
		} else {
			stop();
		}
	};

	onMqChange();
	mq.addEventListener('change', onMqChange);

	return {
		destroy() {
			mq.removeEventListener('change', onMqChange);
			stop();
		},
	};
}
